import { render } from "./Bar9Charts.vue?vue&type=template&id=28ad6b80&scoped=true"
import script from "./Bar9Charts.vue?vue&type=script&lang=js"
export * from "./Bar9Charts.vue?vue&type=script&lang=js"

import "./Bar9Charts.vue?vue&type=style&index=0&id=28ad6b80&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ad6b80"]])

export default __exports__